"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _awaitAsyncGenerator(value) { return new _AwaitValue(value); }

function _wrapAsyncGenerator(fn) { return function () { return new _AsyncGenerator(fn.apply(this, arguments)); }; }

function _AsyncGenerator(gen) { var front, back; function send(key, arg) { return new Promise(function (resolve, reject) { var request = { key: key, arg: arg, resolve: resolve, reject: reject, next: null }; if (back) { back = back.next = request; } else { front = back = request; resume(key, arg); } }); } function resume(key, arg) { try { var result = gen[key](arg); var value = result.value; var wrappedAwait = value instanceof _AwaitValue; Promise.resolve(wrappedAwait ? value.wrapped : value).then(function (arg) { if (wrappedAwait) { resume(key === "return" ? "return" : "next", arg); return; } settle(result.done ? "return" : "normal", arg); }, function (err) { resume("throw", err); }); } catch (err) { settle("throw", err); } } function settle(type, value) { switch (type) { case "return": front.resolve({ value: value, done: true }); break; case "throw": front.reject(value); break; default: front.resolve({ value: value, done: false }); break; } front = front.next; if (front) { resume(front.key, front.arg); } else { back = null; } } this._invoke = send; if (typeof gen.return !== "function") { this.return = undefined; } }

if (typeof Symbol === "function" && Symbol.asyncIterator) { _AsyncGenerator.prototype[Symbol.asyncIterator] = function () { return this; }; }

_AsyncGenerator.prototype.next = function (arg) { return this._invoke("next", arg); };

_AsyncGenerator.prototype.throw = function (arg) { return this._invoke("throw", arg); };

_AsyncGenerator.prototype.return = function (arg) { return this._invoke("return", arg); };

function _AwaitValue(value) { this.wrapped = value; }

function _asyncIterator(iterable) { var method; if (typeof Symbol !== "undefined") { if (Symbol.asyncIterator) { method = iterable[Symbol.asyncIterator]; if (method != null) return method.call(iterable); } if (Symbol.iterator) { method = iterable[Symbol.iterator]; if (method != null) return method.call(iterable); } } throw new TypeError("Object is not async iterable"); }

const defer = require('p-defer');

const Headers = require('./extract-headers');

const LteReader = require('./lte-reader');

function getPadding(size) {
  size &= 511;
  return size && 512 - size;
}

async function discardPadding(reader, size) {
  const overflow = getPadding(size);
  if (overflow) await reader.next(overflow);
}

module.exports = options => {
  options = options || {};
  options.highWaterMark = options.highWaterMark || 1024 * 16;
  return source => _wrapAsyncGenerator(function* () {
    const reader = LteReader(source);
    let gnuLongPath, gnuLongLinkPath, paxGlobal, pax;

    try {
      while (true) {
        let headerBytes;

        try {
          const {
            done,
            value
          } = yield _awaitAsyncGenerator(reader.next(512));
          if (done) return;
          headerBytes = value;
        } catch (err) {
          // Is ok, this is the end of the stream!
          if (err.code === 'ERR_UNDER_READ') return;
          throw err;
        }

        const header = Headers.decode(headerBytes, options.filenameEncoding);
        if (!header) continue;

        if (header.type === 'gnu-long-path') {
          const {
            done,
            value: gnuLongPathBytes
          } = yield _awaitAsyncGenerator(reader.next(header.size));
          if (done) return;
          gnuLongPath = Headers.decodeLongPath(gnuLongPathBytes, options.filenameEncoding);
          yield _awaitAsyncGenerator(discardPadding(reader, header.size));
          continue;
        }

        if (header.type === 'gnu-long-link-path') {
          const {
            done,
            value: gnuLongLinkPathBytes
          } = yield _awaitAsyncGenerator(reader.next(header.size));
          if (done) return;
          gnuLongLinkPath = Headers.decodeLongPath(gnuLongLinkPathBytes, options.filenameEncoding);
          yield _awaitAsyncGenerator(discardPadding(reader, header.size));
          continue;
        }

        if (header.type === 'pax-global-header') {
          const {
            done,
            value: paxGlobalBytes
          } = yield _awaitAsyncGenerator(reader.next(header.size));
          if (done) return;
          paxGlobal = Headers.decodePax(paxGlobalBytes, options.filenameEncoding);
          yield _awaitAsyncGenerator(discardPadding(reader, header.size));
          continue;
        }

        if (header.type === 'pax-header') {
          const {
            done,
            value: paxBytes
          } = yield _awaitAsyncGenerator(reader.next(header.size));
          if (done) return;
          pax = Headers.decodePax(paxBytes, options.filenameEncoding);
          if (paxGlobal) pax = _objectSpread(_objectSpread({}, paxGlobal), pax);
          yield _awaitAsyncGenerator(discardPadding(reader, header.size));
          continue;
        }

        if (gnuLongPath) {
          header.name = gnuLongPath;
          gnuLongPath = null;
        }

        if (gnuLongLinkPath) {
          header.linkname = gnuLongLinkPath;
          gnuLongLinkPath = null;
        }

        if (pax) {
          if (pax.path) header.name = pax.path;
          if (pax.linkpath) header.linkname = pax.linkpath;
          if (pax.size) header.size = parseInt(pax.size, 10);
          header.pax = pax;
          pax = null;
        }

        if (!header.size || header.type === 'directory') {
          yield {
            header,
            body: _wrapAsyncGenerator(function* () {})()
          };
          continue;
        }

        let bytesRemaining = header.size;
        const bodyConsumed = defer(); // Prefetch the first chunk.
        // This allows us to stream entries for small files from the tar without
        // explicitly streaming the body of each.

        const firstChunk = yield _awaitAsyncGenerator(reader.nextLte(Math.min(bytesRemaining, options.highWaterMark)));
        bytesRemaining -= firstChunk.value.length;
        if (!bytesRemaining) bodyConsumed.resolve();

        const body = _wrapAsyncGenerator(function* () {
          try {
            yield firstChunk.value;

            while (bytesRemaining) {
              const {
                done,
                value
              } = yield _awaitAsyncGenerator(reader.nextLte(bytesRemaining));

              if (done) {
                bytesRemaining = 0;
                return;
              }

              bytesRemaining -= value.length;
              yield value;
            }
          } finally {
            bodyConsumed.resolve();
          }
        })();

        yield {
          header,
          body
        }; // Wait for the body to be consumed

        yield _awaitAsyncGenerator(bodyConsumed.promise); // Incase the body was not consumed entirely...

        if (bytesRemaining) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;

          var _iteratorError;

          try {
            for (var _iterator = _asyncIterator(body), _step, _value; _step = yield _awaitAsyncGenerator(_iterator.next()), _iteratorNormalCompletion = _step.done, _value = yield _awaitAsyncGenerator(_step.value), !_iteratorNormalCompletion; _iteratorNormalCompletion = true) {
              const _ = _value;
            } // eslint-disable-line no-unused-vars

          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                yield _awaitAsyncGenerator(_iterator.return());
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }

        yield _awaitAsyncGenerator(discardPadding(reader, header.size));
      }
    } finally {
      yield _awaitAsyncGenerator(reader.return());
    }
  })();
};